import { useOverlayContext } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { handleRequest } from '~/infra/utils';
export const useSendOTPCode = ()=>{
    const overlayContext = useOverlayContext();
    const { t: errorTexts } = useLocaleKeys('errors');
    const sendOTPCode = async (param)=>{
        let { requestOTP, onTooManyRequests, showSuccessToast } = param;
        const result = await handleRequest(requestOTP());
        if (result.success) {
            showSuccessToast && overlayContext.showSuccessToast('We have sent you a new verification code.', 'otp-request-success-toast');
        } else {
            if (result.error.isTooManyAttemptsError()) {
                onTooManyRequests();
                return;
            }
            overlayContext.showErrorToast(errorTexts.unexpected(), 'otp-request-error-toast');
        }
    };
    return {
        sendOTPCode
    };
};
